import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const SentryIntegration = React.lazy(() => import("./SentryIntegration"));

interface SentryIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

// Match PagerDutyIntegration-lazy pattern exactly - no early return
export default function SentryIntegrationLazy(props: SentryIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <SentryIntegration {...props} />
    </Suspense>
  );
}
